import { Category } from './../../components-common/_types/screens/screen';
import { RoleTypeList, viewTypeList } from '@components-common/types';
import { RoleMode, RoleType, ScreenProps, ViewType } from '@components-common/types';
import * as yup from 'yup';
import { roleModeList } from '../../components-common/_types';
import { hasRoute, hasView } from '../../components-common/_utils';
import { hasId } from '../readers/utils';
// YUP Validator
const sectionSchema = yup.object().shape({
  id: yup.string().required(),
  title: yup.string().required(),
  path: yup.string().required(),
});

const roleConfigSchema = yup.object().shape({
  STUDENT: yup.string().oneOf(roleModeList as any),
  LECTURER: yup.string().oneOf(roleModeList as any),
  STUDY_DIRECTOR: yup.string().oneOf(roleModeList as any),
}).noUnknown(true);

const routeInfoSchema = yup.object().shape({
  id: yup.string().required(),
  label: yup.string(),
  to: yup.string().required(),
  roles: yup.mixed().test(
    'is-valid-role-config',
    'Invalid role config',
    (value) => Array.isArray(value) || roleConfigSchema.isValidSync(value)
  ),
  protected: yup.boolean(),
  entityId: yup.string().required(),
  component: yup.string().required(),
  parent: yup.string(),
  breadcrumb: yup.string(),
  key: yup.string(),
  underDevelopment: yup.boolean(),
});

const rootieComponentSchema = yup.object().shape({
  key: yup.string(),
  cat: yup.string().required(),
  type: yup.string().required(),
  Component: yup.mixed().required(),
  typeName: yup.string(),
  props: yup.mixed(),
  children: yup.array().of(yup.lazy(() => rootieComponentSchema) as any),
}) as any;

const screenPropsSchema = yup.object().shape({
  cat: yup.string().oneOf([
    "screen", "table", "widget", "toolbar", "layout", "route", "view", "button", "column"
  ]).required(),
  type: yup.string().oneOf(viewTypeList as any).required(),
  id: yup.string(),
  view: rootieComponentSchema.required(),
  route: routeInfoSchema.required(),
  components: yup.object().shape({
    layout: rootieComponentSchema,
    protected: rootieComponentSchema,
    errorBoundary: yup.mixed(),
  }),
  section: sectionSchema,
});

// Validation function
export const validateScreenProps = (screenProps: any): Promise<any> => {
  return screenPropsSchema.validate(screenProps, { abortEarly: false });
};

export const isCategory = (value: any): value is Category => {
  const categories: Category[] = ["screen", "table", "widget", "toolbar", "layout", "route", "view", "button", "column"];
  return categories.includes(value);
};

export const isViewType = (value: any): value is ViewType => {
  return viewTypeList.includes(value);
};

export const isRoleMode = (value: any): value is RoleMode => {
  return roleModeList.includes(value);
};

export const isRoleType = (value: any): value is RoleType => {
  return RoleTypeList.includes(value);
};

export const isScreenProps = (value: any): value is ScreenProps => {
  try {
    const result = hasRoute(value) && hasView(value) && hasId(value) ? true : false;
    return result;
  } catch (err) {
    return false;
  }
};
